import(/* webpackMode: "eager" */ "/app/frontend/apps/org/src/app/[locale]/not-found.tsx");
